import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Section, Spinner } from "../components/Bits";
import PageHero from "../components/PageHero";
import { BookOpen, Clock } from "lucide-react";

const CATEGORY_LABELS = {
  wissen: "Wissen",
  rezept: "Rezepte",
  saison: "Saison",
  sicherheit: "Sicherheit",
  luxemburg: "Luxemburg",
};

const CATEGORY_COLORS = {
  wissen: "rgba(140,138,106,0.18)",
  rezept: "rgba(203,163,110,0.20)",
  saison: "rgba(180,160,80,0.18)",
  sicherheit: "rgba(167,58,58,0.14)",
  luxemburg: "rgba(95,91,62,0.18)",
};

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("");

  useEffect(() => {
    setLoading(true);
    const q = category ? `?category=${category}` : "";
    api.get(`/articles${q}`).then((r) => setArticles(r.data || [])).finally(() => setLoading(false));
  }, [category]);

  return (
    <>
      <PageHero slug="magazin" variant="soft" defaultOverline="Magazin" defaultTitle="Wildkräuter-Wissen" defaultSubtitle="Geschichten, Rezepte, Sicherheitshinweise und saisonale Tipps – direkt aus den luxemburgischen Wäldern und Wiesen." />
      <Section className="!pt-12">

      <div className="flex flex-wrap gap-2 mb-8" data-testid="blog-categories">
        <button
          onClick={() => setCategory("")}
          className={`px-4 py-2 rounded-full text-sm border transition-colors ${!category ? "bg-[var(--wp-primary)] text-[var(--wp-cream)] border-[var(--wp-primary)]" : ""}`}
          style={category ? { borderColor: "var(--wp-border)" } : {}}
          data-testid="blog-filter-all"
        >
          Alle
        </button>
        {Object.entries(CATEGORY_LABELS).map(([k, l]) => (
          <button
            key={k}
            onClick={() => setCategory(k)}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${category === k ? "bg-[var(--wp-primary)] text-[var(--wp-cream)] border-[var(--wp-primary)]" : ""}`}
            style={category !== k ? { borderColor: "var(--wp-border)" } : {}}
            data-testid={`blog-filter-${k}`}
          >
            {l}
          </button>
        ))}
      </div>

      {loading ? <Spinner /> : (
        articles.length === 0 ? (
          <div className="plant-card p-12 text-center opacity-70" data-testid="blog-empty">
            Noch keine Artikel in dieser Kategorie.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {articles.map((a) => (
              <Link key={a.id} to={`/magazin/${a.slug}`} className="plant-card overflow-hidden flex flex-col group" data-testid={`article-card-${a.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={a.cover_image} alt={(a.cover_image || "").startsWith("/fotos/") && a.cover_alt ? a.cover_alt : a.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <span
                    className="self-start text-[10px] uppercase tracking-wider px-2 py-1 rounded-full mb-3"
                    style={{ backgroundColor: CATEGORY_COLORS[a.category] || "rgba(0,0,0,0.05)" }}
                  >
                    {CATEGORY_LABELS[a.category] || a.category}
                  </span>
                  <h3 className="font-display text-2xl mb-2 leading-tight">{a.title}</h3>
                  <p className="text-sm opacity-80 flex-1">{a.excerpt}</p>
                  <div className="flex items-center gap-3 mt-4 text-xs opacity-60">
                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {new Date(a.created_at).toLocaleDateString("de-DE")}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )
      )}
    </Section>
    </>
  );
}
